/*
 * @Author: 李文敬
 * @version: 1.0.0
 * @Company: 和顺旭基(深圳)中医药科技有限公司
 * @Description:
 * @Date: 2021-06-21 14:49:25
 * @LastEditors: 李文敬
 * @LastEditTime: 2022-08-03 11:32:13
 */
import Vue from 'vue'

import '@/assets/css/reset.css'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css'
Vue.use(ElementUI)

import App from './App'
import router from './router'

import store from './store'

import Banner from '@/components/banner'
import MyCould from '@/components/myCould'

Vue.component('Banner', Banner)
Vue.component('MyCould', MyCould)

// 引入图标库
import iconfont from '@/assets/iconfont/iconfont.css'
import '@/assets/iconfont/iconfont.js'
import './icons' // icon

import {
  deepCopy,
  setLoc,
  getLoc,
  delLoc
} from '@/utils'
Vue.prototype.$deep = deepCopy
Vue.prototype.$setLoc = setLoc
Vue.prototype.$getLoc = getLoc
Vue.prototype.$delLoc = delLoc

Vue.config.productionTip = false

import VideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
Vue.use(VideoPlayer)

// import axios from '@/https'

// Vue.prototype.$axios = axios
// require('@/mock')

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  iconfont,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js